/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import casa from "../../../assets/img/casa.png";
import departamento from "../../../assets/img/departamento.png";
import cabaña from "../../../assets/img/cabaña.png";
import hotel from "../../../assets/img/hotel.png";

import wifi from "../../../assets/img/wifi.png";
import pileta from "../../../assets/img/natacion.png";
import televisor from "../../../assets/img/televisor.png";
import estacionamiento from "../../../assets/img/estacionamiento.png";
import cocina from "../../../assets/img/coccion.png";
import refrigerador from "../../../assets/img/refrigerador.png";
import ropa from "../../../assets/img/manta.png";
import perchas from "../../../assets/img/percha.png";
import armario from "../../../assets/img/armario.png";

import excursionesDia from "../../../assets/img/excursiones-dia.png";
import tourCompletos from "../../../assets/img/tour-dia-completo.png";
import gastronomico from "../../../assets/img/gastronomia.png";
import recorrido from "../../../assets/img/recorrido-auto.png";
import aventura from "../../../assets/img/aventura.png";
import toursPrivado from "../../../assets/img/tour-turistico-privado.png";
import cataVino from "../../../assets/img/cata-vino.png";
import tourPie from "../../../assets/img/tours-pie.png";
import naturaleza from "../../../assets/img/naturaleza.png";
import arqueologo from "../../../assets/img/arqueologo.png";
import almuerzo from "../../../assets/img/almuerzo.png";
import desayuno from "../../../assets/img/desayuno.png";
import merienda from "../../../assets/img/meriendas.png";
import bebidas from "../../../assets/img/bebidas-sin-alcohol.png";
import traslados from "../../../assets/img/traslados.png";
import guia from "../../../assets/img/guia-turistico.png";
import cancelacion from "../../../assets/img/cancelar-gratis.png";
import espanol from "../../../assets/img/espanol.png";
import accesible from "../../../assets/img/silla-de-ruedas.png";
import mascotas from "../../../assets/img/pista.png";
import recogida from "../../../assets/img/recorrido-auto.png";
import servicio from "../../../assets/img/ayuda-seguridad.png";

import tranquilo from "../../../assets/img/tranquilo.png";
import unico from "../../../assets/img/unico.png";
import familiar from "../../../assets/img/familia.png";
import espacioso from "../../../assets/img/espacioso.png";
import { FilterIcon } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "../Sheet";

const Filter = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const tabs = [
    { name: "Filtrar alojamientos", value: "alojamiento" },
    { name: "Filtrar excursiones", value: "excursiones" },
  ];
  const [tab, setTab] = useState("alojamiento");
  const [filter, setFilter] = useState<any>({
    travellers: parseInt(searchParams.get("travellers") || "0"),
    space: searchParams.get("space") || "",
    description: searchParams.get("description") || "",
    activities: searchParams.get("activities") || "",
    type: searchParams.get("type") || "",
    services: searchParams.get("services") || "",
    bedrooms: parseInt(searchParams.get("bedrooms") || "0"),
    beds: parseInt(searchParams.get("beds") || "0"),
    bathrooms: parseInt(searchParams.get("bathrooms") || "0"),
    priceMin: parseInt(searchParams.get("priceMin") || "0"),
    priceMax: parseInt(searchParams.get("priceMax") || "0"),
  });
  const [modal, setModal] = useState(false);

  const cantidad = [
    "Cualquiera",
    "1+",
    "2+",
    "3+",
    "4+",
    "5+",
    "6+",
    "7+",
    "8+",
  ];

  const descripciones = [
    {
      name: "Accesible",
      icon: familiar,
    },
    {
      name: "Familiar",
      icon: familiar,
    },
    {
      name: "Tranquilo",
      icon: tranquilo,
    },
    {
      name: "Extensa",
      icon: espacioso,
    },
    {
      name: "Exclusiva",
      icon: unico,
    },
    {
      name: "Organizada",
      icon: espacioso,
    },
  ];

  const espacio = [
    {
      name: "Casa",
      icon: casa,
    },
    {
      name: "Departamento",
      icon: departamento,
    },
    {
      name: "Hotel",
      icon: hotel,
    },
    {
      name: "Cabaña",
      icon: cabaña,
    },
  ];

  const servicios = [
    {
      name: "Wifi",
      icon: wifi,
    },
    {
      name: "Pileta",
      icon: pileta,
    },
    {
      name: "Televisor",
      icon: televisor,
    },
    {
      name: "Estacionamiento",
      icon: estacionamiento,
    },
    {
      name: "Cocina",
      icon: cocina,
    },
    {
      name: "Refrigerador",
      icon: refrigerador,
    },
    {
      name: "Ropa de cama",
      icon: ropa,
    },
    {
      name: "Perchas",
      icon: perchas,
    },
    {
      name: "Espacio para guardar ropa",
      icon: armario,
    },
  ];

  const actividades = [
    {
      name: "Excursiones de día",
      icon: excursionesDia,
    },
    {
      name: "Tour días completos",
      icon: tourCompletos,
    },
    {
      name: "Tours gastronómicos",
      icon: gastronomico,
    },
    {
      name: "Recorridos en auto",
      icon: recorrido,
    },
    {
      name: "Tours turísticos",
      icon: tourCompletos,
    },
    {
      name: "Tours de aventura",
      icon: aventura,
    },
    {
      name: "Tours turisticos privados",
      icon: toursPrivado,
    },
    {
      name: "Tour de medio días",
      icon: tourCompletos,
    },
    {
      name: "Cata de vino",
      icon: cataVino,
    },
    {
      name: "Tours a pie",
      icon: tourPie,
    },
    {
      name: "Paseos por la naturaleza",
      icon: naturaleza,
    },
    {
      name: "Visitas arqueológicas",
      icon: arqueologo,
    },
    {
      name: "Almuerzo",
      icon: almuerzo,
    },
    {
      name: "Desayuno",
      icon: desayuno,
    },
    {
      name: "Merienda",
      icon: merienda,
    },
    {
      name: "Bebidas",
      icon: bebidas,
    },
    {
      name: "Traslados",
      icon: traslados,
    },
    {
      name: "Guía profesional",
      icon: guia,
    },
    {
      name: "Cancelación gratis",
      icon: cancelacion,
    },
    {
      name: "Actividades en español",
      icon: espanol,
    },
    {
      name: "Accesible a sillas de ruedas",
      icon: accesible,
    },
    {
      name: "Admite mascotas",
      icon: mascotas,
    },
    {
      name: "Recogida en alojamiento",
      icon: recogida,
    },
    {
      name: "Servicio privado",
      icon: servicio,
    },
  ];
  return (
    <div className="lg:w-auto h-full justify-center">
      <button style={{ borderRadius: "50px" }} className="cursor-pointer  flex btn  btn-outline-2 w-full h-full justify-center items-center " onClick={() => setModal(true)}>
        <span className="flex text-white items-center justify-center" style={{
          fontSize: "12px"
        }}>
          <FilterIcon className="lg:me-2" style={{ width: "20px" }} />
        </span>
      </button>

      <Sheet open={modal} onOpenChange={setModal}>
        <SheetContent
          side="right"
          className="w-full sm:max-w-xl overflow-auto"
        >
          <SheetHeader>
            <SheetTitle>Filtros</SheetTitle>
          </SheetHeader>

          <div>
            <div className={`${tab == "excursiones" ? "" : "hidden"}`}>
              <div className="grid grid-cols-2">
                {tabs.map((t: any, index: number) => {
                  return (
                    <label
                      key={
                        index
                      }
                      className={`cursor-pointer border font-bold text-md mb-4 block p-3 hover:opacity-[1] ${t.value == tab ? "" : "opacity-[0.4]"
                        }`}
                    >
                      {t.name}
                      <button
                        className="hidden"
                        onClick={() => setTab(t.value)}
                      ></button>
                    </label>
                  );
                })}
              </div>
              <div className="py-2 px-[20px]">
                <div
                  className="grid md:grid-cols-3 p-3 border"
                  style={{ borderRadius: "10px 10px 10px 10px" }}
                >
                  <label
                    className={`cursor-pointer block  py-3 text-center font-bold border-0 text-md ${filter?.space == "Actividad grupal"
                      ? "bg-primary text-white"
                      : "bg-white text-black"
                      }`}
                    style={{ borderRadius: "10px 10px 10px 10px" }}
                  >
                    Actividad grupal
                    <button
                      className="hidden"
                      onClick={() => {
                        setFilter({ ...filter, space: "Actividad grupal" });
                      }}
                    ></button>
                  </label>
                  <label
                    className={`cursor-pointer block  py-3 text-center font-bold border-0 text-md ${filter?.space == "Actividad individual"
                      ? "bg-primary text-white"
                      : "bg-white text-black"
                      }`}
                    style={{ borderRadius: "10px 10px 10px 10px" }}
                  >
                    Actividad individual
                    <button
                      className="hidden"
                      onClick={() => {
                        setFilter({ ...filter, space: "Actividad individual" });
                      }}
                    ></button>
                  </label>
                  <label
                    className={`cursor-pointer block  py-3 text-center font-bold border-0 text-md ${filter?.space == "Familiar exclusiva"
                      ? "bg-primary text-white"
                      : "bg-white text-black"
                      }`}
                    style={{ borderRadius: "10px 10px 10px 10px" }}
                  >
                    Familiar exclusiva
                    <button
                      className="hidden"
                      onClick={() => {
                        setFilter({ ...filter, space: "Familiar exclusiva" });
                      }}
                    ></button>
                  </label>
                </div>
              </div>
              <hr className="border border-gray-10 mx-[40px] my-5 block" />
              <div className="py-2 px-[20px] ">
                <label className="font-bold text-md  block">
                  Rango de precios
                </label>
                <span className="block mb-5">
                  Precios por noche (impuestos y tarifas no incluidos)
                </span>
                <div className="grid md:grid-cols-2 gap-10">
                  <div>
                    <span className="block font-bold">Minimo</span>
                    <input
                      className="bg-white border border-black text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-black block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500"
                      defaultValue={filter?.priceMin}
                      onChange={(e) => {
                        return setFilter({ ...filter, priceMin: e.target.value });
                      }}
                      placeholder="Minimo"
                    ></input>
                  </div>
                  <div>
                    <span className="block font-bold">Maximo</span>
                    <input
                      type="number"
                      className="bg-white border border-black text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-black block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500"
                      defaultValue={filter?.priceMax}
                      onChange={(e) => {
                        return setFilter({ ...filter, priceMax: e.target.value });
                      }}
                      placeholder="Maximo"
                    />
                  </div>
                </div>
              </div>
              <hr className="border border-gray-10 mx-[40px] my-5 block" />
              <div className="py-2 px-[20px]">
                <label className="font-bold text-md block">Actividades</label>

                <div className="inline">
                  {actividades.map((t: any, index: any) => {
                    return (
                      <label
                        key={index}
                        className={`inline-block border p-3 m-2 cursor-pointer ${filter?.activities
                          ? filter?.activities.split(",").indexOf(t.name) >= 0
                            ? "border-black"
                            : "border"
                          : "border"
                          }`}
                        style={{ borderRadius: "20px" }}
                      >
                        <span className="flex">
                          <img
                            src={t.icon}
                            width={20}
                            className="me-2"
                            alt=""
                          />
                          {t.name}
                        </span>
                        <button
                          className="hidden"
                          onClick={() => {
                            let activities = filter?.activities ?? "";
                            activities = activities.split(",");

                            if (activities.length >= 1) {
                              if (activities.indexOf(t.name) >= 0) {
                                delete activities[activities.indexOf(t.name)];
                              } else {
                                activities.push(t.name);
                              }
                            } else {
                              activities = [t.name];
                            }

                            activities = activities.filter(
                              (s: string) => s !== null && s !== ""
                            );
                            setFilter({
                              ...filter,
                              activities: activities.join(","),
                            });
                          }}
                        ></button>
                      </label>
                    );
                  })}
                </div>
              </div>
              <hr className="border border-gray-10 mx-[40px] my-5 block" />

              <div className="py-2 px-[20px]">
                <label className="font-bold text-md block">
                  Aspectos destacados
                </label>

                <div className="inline">
                  {descripciones.map((t: any, index: any) => {
                    return (
                      <label
                        key={index}
                        className={`inline-block border p-3 m-2 cursor-pointer text-black  opacity-1
                        ${filter?.description
                            ? filter?.description.split(",").indexOf(t.name) >=
                              0
                              ? "border-black"
                              : "border"
                            : "border"
                          }`}
                        style={{ borderRadius: "20px" }}
                      >
                        <span className="flex text-black">
                          <img
                            src={t.icon}
                            width={20}
                            className="me-2"
                            alt=""
                          />
                          {t.name}
                        </span>
                        <button
                          className="hidden"
                          onClick={() => {
                            let description = filter?.description ?? "";
                            description = description.split(",");

                            if (description.length >= 1) {
                              if (description.indexOf(t.name) >= 0) {
                                delete description[description.indexOf(t.name)];
                              } else {
                                description.push(t.name);
                              }
                            } else {
                              description = [t.name];
                            }

                            description = description.filter(
                              (s: string) => s !== null && s !== ""
                            );
                            setFilter({
                              ...filter,
                              description: description.join(","),
                            });
                          }}
                        ></button>
                      </label>
                    );
                  })}
                </div>
              </div>
            </div>

            <div className={`${tab == "alojamiento" ? "" : "hidden"}`}>
              <div className="grid grid-cols-2">
                {tabs.map((t: any, index: number) => {
                  return (
                    <label
                      key={index}
                      className={`cursor-pointer border font-bold text-md mb-4 block p-3 hover:opacity-[1] ${t.value == tab ? "" : "opacity-[0.4]"
                        }`}
                    >
                      {t.name}
                      <button
                        className="hidden"
                        onClick={() => setTab(t.value)}
                      ></button>
                    </label>
                  );
                })}
              </div>
              <div className="py-2 px-[20px]">
                <div
                  className="grid md:grid-cols-3 p-3 border"
                  style={{ borderRadius: "10px 10px 10px 10px" }}
                >
                  <label
                    className={`cursor-pointer block btn text-md ${filter?.space == ""
                      ? "btn-filled-2"
                      : "bg-white text-black"
                      }`}
                    style={{ borderRadius: "10px 10px 10px 10px" }}
                  >
                    Cualquiera
                    <button
                      className="hidden"
                      onClick={() => {
                        setFilter({ ...filter, space: "" });
                      }}
                    ></button>
                  </label>
                  <label
                    className={`cursor-pointer block btn text-md ${filter?.space == "Una habitacion"
                      ? "btn-filled-2"
                      : "bg-white text-black"
                      }`}
                    style={{ borderRadius: "10px 10px 10px 10px" }}
                  >
                    Una habitacion
                    <button
                      className="hidden"
                      onClick={() => {
                        setFilter({ ...filter, space: "Una habitacion" });
                      }}
                    ></button>
                  </label>
                  <label
                    className={`cursor-pointer block btn text-md ${filter?.space == "Alojamiento completo"
                      ? "btn-filled-2"
                      : "bg-white text-black"
                      }`}
                    style={{ borderRadius: "10px 10px 10px 10px" }}
                  >
                    Alojamiento completo
                    <button
                      className="hidden"
                      onClick={() => {
                        setFilter({ ...filter, space: "Alojamiento completo" });
                      }}
                    ></button>
                  </label>
                </div>
              </div>
              <hr className="border border-gray-10 mx-[40px] my-5 block" />
              <div className="py-2 px-[20px] ">
                <label className="font-bold text-md  block">
                  Rango de precios
                </label>
                <span className="block mb-5">
                  Precios por noche (impuestos y tarifas no incluidos)
                </span>
                <div className="grid md:grid-cols-2 gap-10">
                  <div>
                    <span className="block font-bold">Minimo</span>
                    <input
                      className="bg-white border border-black text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-black block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500"
                      defaultValue={filter?.priceMin}
                      onChange={(e) => {
                        return setFilter({ ...filter, priceMin: e.target.value });
                      }}
                      placeholder="Minimo"
                    ></input>
                  </div>
                  <div>
                    <span className="block font-bold">Maximo</span>
                    <input
                      type="number"
                      className="bg-white border border-black text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-black block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500"
                      defaultValue={
                        filter?.priceMax
                      }
                      onChange={(e) => {

                        return setFilter({ ...filter, priceMax: e.target.value });
                      }}
                      placeholder="Maximo"
                    />
                  </div>
                </div>
              </div>
              <hr className="border border-gray-10 mx-[40px] my-5 block" />
              <div className="py-2 px-[20px]">
                <div className="mb-4">
                  <label className="font-bold text-md">
                    Habitaciones y camas
                  </label>
                </div>

                <div className="grid md:grid-cols-2 grid-cols-1 gap-1 mb-3">
                  <span className="text-black text-xl">Viajeros</span>
                  <div className="flex md:justify-end">
                    <label
                      className={`cursor-pointer border border-grey-10 justify-center items-center flex w-[50px] h-[50px]`}
                      style={{ borderRadius: "50%", fontSize: "30px" }}
                    >
                      -
                      <button
                        className="hidden"
                        onClick={() => {
                          if (filter?.travellers > 0) {
                            setFilter({
                              ...filter,
                              travellers: filter?.travellers - 1,
                            });
                          }
                        }}
                      ></button>
                    </label>
                    <span className="font-bold block mx-4 flex text-center text-black text-xl justify-center items-center h-[50px] w-[100px]">
                      {cantidad[filter?.travellers]}
                    </span>
                    <label
                      className={`cursor-pointer border border-grey-10 justify-center items-center  flex w-[50px] h-[50px]`}
                      style={{ borderRadius: "50%", fontSize: "30px" }}
                    >
                      +
                      <button
                        className="hidden"
                        onClick={() => {
                          if (filter?.travellers < 8) {
                            setFilter({
                              ...filter,
                              travellers: filter?.travellers + 1,
                            });
                          }
                        }}
                      ></button>
                    </label>
                  </div>
                </div>

                <div className="grid md:grid-cols-2 grid-cols-1 gap-1 mb-3">
                  <span className="text-black text-xl">Dormitorios</span>
                  <div className="flex md:justify-end">
                    <label
                      className={`cursor-pointer border border-grey-10 justify-center items-center flex w-[50px] h-[50px]`}
                      style={{ borderRadius: "50%", fontSize: "30px" }}
                    >
                      -
                      <button
                        className="hidden"
                        onClick={() => {
                          if (filter?.bedrooms > 0) {
                            setFilter({
                              ...filter,
                              bedrooms: filter?.bedrooms - 1,
                            });
                          }
                        }}
                      ></button>
                    </label>
                    <span className="font-bold block mx-4 flex text-center text-black text-xl justify-center items-center h-[50px] w-[100px]">
                      {cantidad[filter?.bedrooms]}
                    </span>
                    <label
                      className={`cursor-pointer border border-grey-10 justify-center items-center  flex w-[50px] h-[50px]`}
                      style={{ borderRadius: "50%", fontSize: "30px" }}
                    >
                      +
                      <button
                        className="hidden"
                        onClick={() => {
                          if (filter?.bedrooms < 8) {
                            setFilter({
                              ...filter,
                              bedrooms: filter?.bedrooms + 1,
                            });
                          }
                        }}
                      ></button>
                    </label>
                  </div>
                </div>

                <div className="grid md:grid-cols-2 grid-cols-1 gap-1 mb-3">
                  <span className="text-black text-xl">Camas</span>
                  <div className="flex flex md:justify-end">
                    <label
                      className={`cursor-pointer  border border-grey-10 justify-center items-center flex w-[50px] h-[50px]`}
                      style={{ borderRadius: "50%", fontSize: "30px" }}
                    >
                      -
                      <button
                        className="hidden"
                        onClick={() => {
                          if (filter?.beds > 0) {
                            setFilter({
                              ...filter,
                              beds: filter?.beds - 1,
                            });
                          }
                        }}
                      ></button>
                    </label>
                    <span className="font-bold block mx-4 flex text-center text-xl text-black justify-center items-center h-[50px] w-[100px]">
                      {cantidad[filter?.beds]}
                    </span>
                    <label
                      className={`cursor-pointer border border-grey-10 justify-center items-center  flex w-[50px] h-[50px]`}
                      style={{ borderRadius: "50%", fontSize: "30px" }}
                    >
                      +
                      <button
                        className="hidden"
                        onClick={() => {
                          if (filter?.beds < 8) {
                            setFilter({
                              ...filter,
                              beds: filter?.beds + 1,
                            });
                          }
                        }}
                      ></button>
                    </label>
                  </div>
                </div>

                <div className="grid md:grid-cols-2 grid-cols-1 gap-1 mb-3">
                  <span className="text-black text-xl">Baños</span>
                  <div className="flex flex md:justify-end">
                    <label
                      className={`cursor-pointer  border border-grey-10 justify-center items-center flex w-[50px] h-[50px]`}
                      style={{ borderRadius: "50%", fontSize: "30px" }}
                    >
                      -
                      <button
                        className="hidden"
                        onClick={() => {
                          if (filter?.bathrooms > 0) {
                            setFilter({
                              ...filter,
                              bathrooms: filter?.bathrooms - 1,
                            });
                          }
                        }}
                      ></button>
                    </label>
                    <span className="font-bold block mx-4 flex text-xl text-center text-black justify-center items-center h-[50px] w-[100px]">
                      {cantidad[filter?.bathrooms]}
                    </span>
                    <label
                      className={`cursor-pointer  border border-grey-10 justify-center items-center  flex w-[50px] h-[50px]`}
                      style={{ borderRadius: "50%", fontSize: "30px" }}
                    >
                      +
                      <button
                        className="hidden"
                        onClick={() => {
                          if (filter?.bathrooms < 8) {
                            setFilter({
                              ...filter,
                              bathrooms: filter?.bathrooms + 1,
                            });
                          }
                        }}
                      ></button>
                    </label>
                  </div>
                </div>
              </div>
              <hr className="border border-gray-10 mx-[40px] my-5 block" />
              <div className="py-2 px-[20px]">
                <label className="font-bold text-md block">
                  Tipo de propiedad
                </label>

                <div className="inline">
                  {espacio.map((t: any, index: any) => {
                    return (
                      <label
                        key={index}
                        className={`inline-block border p-3 m-2 cursor-pointer ${filter?.type
                          ? filter?.type.split(",").indexOf(t.name) >= 0
                            ? "border-black"
                            : "border"
                          : "border"
                          }`}
                        style={{ borderRadius: "20px" }}
                      >
                        <span className="flex">
                          <img
                            src={t.icon}
                            width={20}
                            className="me-2"
                            alt=""
                          />
                          {t.name}
                        </span>
                        <button
                          className="hidden"
                          onClick={() => {
                            let types = filter?.type ?? "";
                            types = types.split(",");

                            if (types.length >= 1) {
                              if (types.indexOf(t.name) >= 0) {
                                delete types[types.indexOf(t.name)];
                              } else {
                                types.push(t.name);
                              }
                            } else {
                              types = [t.name];
                            }

                            types = types.filter(
                              (s: string) => s !== null && s !== ""
                            );
                            setFilter({
                              ...filter,
                              type: types.join(","),
                            });
                          }}
                        ></button>
                      </label>
                    );
                  })}
                </div>
              </div>
              <hr className="border border-gray-10 mx-[40px] my-5 block" />

              <div className="py-2 px-[20px]">
                <label className="font-bold text-md block">Servicios</label>

                <div className="inline">
                  {servicios.map((t: any, index: any) => {
                    return (
                      <label
                        key={index}
                        className={`inline-block border p-3 m-2 cursor-pointer text-black  opacity-1
                        ${filter?.services
                            ? filter?.services.split(",").indexOf(t.name) >= 0
                              ? "border-black"
                              : "border"
                            : "border"
                          }`}
                        style={{ borderRadius: "20px" }}
                      >
                        <span className="flex text-black">
                          <img
                            src={t.icon}
                            width={20}
                            className="me-2"
                            alt=""
                          />
                          {t.name}
                        </span>
                        <button
                          className="hidden"
                          onClick={() => {
                            let servicios = filter?.services ?? "";
                            servicios = servicios.split(",");

                            if (servicios.length >= 1) {
                              if (servicios.indexOf(t.name) >= 0) {
                                delete servicios[servicios.indexOf(t.name)];
                              } else {
                                servicios.push(t.name);
                              }
                            } else {
                              servicios = [t.name];
                            }

                            servicios = servicios.filter(
                              (s: string) => s !== null && s !== ""
                            );
                            setFilter({
                              ...filter,
                              services: servicios.join(","),
                            });
                          }}
                        ></button>
                      </label>
                    );
                  })}
                </div>
              </div>
            </div>

            <div className="flex justify-between w-full">
              <label className="cursor-pointer block font-bold">
                Borrar todo
                <button
                  className="hidden"
                  onClick={() => {
                    localStorage.removeItem("filter");
                    setFilter({
                      description: "",
                      activities: "",
                      type: "",
                      services: "",
                      travellers: 0,
                      bedrooms: 0,
                      beds: 0,
                      bathrooms: 0,
                      priceMin: 0,
                      priceMax: 0
                    });

                    // Navegar sin query parameters para limpiar filtros
                    if (tab == "alojamiento") {
                      navigate("/alojamientos");
                    } else if (tab == "excursiones") {
                      navigate("/excursiones");
                    }
                    setModal(false);
                  }}
                ></button>
              </label>
              <label
                className="cursor-pointer btn btn-filled-2"
                style={{ borderRadius: "50px" }}
              >
                Mostrar resultados
                <button
                  className="hidden"
                  onClick={() => {
                    // Función para construir query parameters desde el filtro
                    const buildQueryParams = (filterData: any) => {
                      const params = new URLSearchParams();

                      // Solo agregar parámetros que tengan valores válidos
                      Object.entries(filterData).forEach(([key, value]) => {
                        if (value !== null && value !== undefined && value !== "" && value !== 0) {
                          params.append(key, String(value));
                        }
                      });

                      return params.toString();
                    };

                    if (tab == "alojamiento") {
                      // Mantener localStorage para compatibilidad
                      localStorage.setItem("filter", JSON.stringify(filter));

                      // Construir URL con query parameters
                      const queryString = buildQueryParams(filter);
                      const url = queryString ? `/alojamientos?${queryString}` : "/alojamientos";

                      navigate(url);
                      setModal(false);
                    } else if (tab == "excursiones") {
                      // Mantener localStorage para compatibilidad
                      localStorage.setItem("filter", JSON.stringify(filter));

                      // Construir URL con query parameters
                      const queryString = buildQueryParams(filter);
                      const url = queryString ? `/excursiones?${queryString}` : "/excursiones";

                      navigate(url);
                      setModal(false);
                    }
                  }}
                ></button>
              </label>
            </div>
          </div>
        </SheetContent>
      </Sheet>
    </div>
  );
};

export default Filter;
